import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SearchFilters from '../components/SearchFilters';

export interface SearchLayoutContextType {
    showMobileFilters: boolean;
    setShowMobileFilters: React.Dispatch<React.SetStateAction<boolean>>;
}

const SearchLayout: React.FC = () => {
    const { i18n } = useTranslation();
    const [showMobileFilters, setShowMobileFilters] = useState(false);
    const isArabic = i18n.language === 'ar';

    return (
        <div className="container-fluid py-4">
            <div className="row g-4">
                {/* Sidebar - Desktop always visible, Mobile toggle */}
                <div className={`col-lg-3 col-xl-3 ${showMobileFilters ? 'd-block' : 'd-none d-lg-block'}`}>
                    <div className="search-filters-wrapper">
                        <SearchFilters />
                    </div>
                </div>

                {/* Main Content */}
                <div className="col-lg-9 col-xl-9">
                    <Outlet context={{ showMobileFilters, setShowMobileFilters } satisfies SearchLayoutContextType} />
                </div>
            </div>
        </div>
    );
};

export default SearchLayout;
